<template>
	<div class="floor4">


<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 653.75 309" enable-background="new 0 0 653.75 309" xml:space="preserve">
<path fill="#E7EAE8" d="M581.166,83.046c0-0.221-0.123-0.207-0.318-0.049C581.04,83.228,581.166,83.292,581.166,83.046"/>
<path fill="#E7EAE8" d="M126.826,182.228H91.629v-32.543h35.197V182.228z M635.646,127.71l-0.144-7.232l-46.65-0.834l-10.894-9.458
	l0.178-23.081c0,0-0.358-5.167-0.011-4.224c-0.271-0.734-2.313-3.859-2.313-3.859l-46.625,0.156l-3.851,3.326v5.965l-0.411,65.115
	l-10.344,11.158l-127.972-0.037l-6.704-7.788l-0.278-33.936l-70.951,0.557V153.3l-10.616,11.128c0,0-131.29,0.007-137.781,0.119
	c-8.872,0.158-8.872,0.158-11.665-13.193c0-3.616,0.557-38.386,0.557-38.386H71.238l-0.279,50.345c0,0-29.052-0.276-34.08-0.276
	s-10.055-1.391-13.966-5.287c-3.911-3.892-5.332-12.779-5.332-12.779l0.157,26.602l53.237,0.473v49.061l77.082,0.279v-44.998
	l4.748-4.198l144.977-1.111l10.895,11.15l-0.723,30.178l71.231,0.278l0.251-32.94l7.754-7.854l191.605-0.23l-0.279-34.212
	l10.057-10.015L635.646,127.71z"/>
<polyline fill="#E7EAE8" points="90.392,151.201 90.811,183.886 127.475,184.304 127.056,149.526 93.954,149.107 "/>
<polygon fill="#DDE5A3" points="588.245,119.357 578.19,109.339 578.125,82.88 575.817,79.177 529,79.125 526.938,80.917 
	525.313,82.354 525.63,154.804 515.702,164.69 435.812,164.391 436.531,111.313 467.777,111.23 467.99,38.81 534.536,38.643 
	535.374,41.982 539.139,42.074 539.471,27.204 564.578,27.287 564.908,42.324 568.245,42.241 568.412,39.25 636.219,39.499 
	636.007,96.736 633.386,96.819 633.719,100.059 635.493,100.974 635.389,119.498 "/>
<polygon fill="#DDE5A3" points="636.028,126.356 635.94,206.975 586.313,207.227 585.98,203.783 562.629,203.7 562.377,206.387 
	434.52,206.053 434.936,171.367 577.724,171.453 577.974,136.687 588.149,126.44 "/>
<path fill="#C4E3F7" d="M434.168,164.062l-47.736,0.461l-8.483-9.253l0.805-31.375l-8.959,0.354l-61.173-0.419l0.104,29.436
	l-10.903,11.527l-96.792-0.419l0.847-35.831h6.922l0.158-18.051h36.645l-0.148,18.261h6.705V75.12l38.874-0.177
	c0,0,6.579,0.496,11.397,5.314c4.819,4.819,5.36,13.257,5.36,13.257l10.991,0.252l0.837-18.877l116.28-0.032l-0.099,89.13
	L434.168,164.062z"/>
<polygon fill="#C4E3F7" points="434.967,171.3 435.128,260.564 395.642,260.144 395.221,255.117 364.216,255.117 363.797,260.144 
	303.458,260.144 303.877,254.276 271.614,253.021 271.614,259.725 251.92,259.725 251.5,242.127 201.895,242.384 201.638,184.722 
	199.125,184.722 199.125,171.315 297.592,171.733 308.52,182.562 307.682,212.313 378.88,212.377 378.846,180.601 386.807,171.801 
	434.153,171.188 "/>
<path fill="#90C5E5" d="M145.208,92.441c0,0,0.212-7.403,4.461-11.637c11.379-11.343,32.552-4.826,52.228-5.785l-0.157,89.691
	l-42.165,0.005c0,0-5.098,0.44-7.686-3.131c-1.625-2.242-3.1-7.241-3.1-7.241l0.396-40.218l-6.313-0.037l-71.877-0.144
	l-0.654,50.173c0,0-32.014-0.673-36.589-0.673c-4.576,0-8.68-2.42-12.439-6.169c-3.759-3.745-4.249-11.403-4.249-11.403
	l0.781-71.657h116.636v17.393"/>
<polygon fill="#90C5E5" points="17.574,171.403 69.69,171.613 70.344,221.463 147.867,221.037 148.137,176.5 153.693,170.959 
	199.117,171.315 199.117,184.722 201.638,184.722 201.5,258.468 181.15,259.256 181.108,253.44 148.791,253.39 149.117,259.256 
	88.648,259.256 88.648,253.39 57.27,253.717 56.942,259.256 17.067,258.275 16.413,195.722 22.295,195.722 22.295,181.06 
	17.067,181.387 "/>
<polygon fill="#90C5E5" points="76.554,119.156 141.927,119.482 142.32,159.086 138.079,163.218 126.951,163.68 126.237,150.108 
	92.244,150.435 92.57,163.466 75.901,163.142 "/>
<polygon fill="#90C5E5" points="76.554,171.287 91.916,171.287 92.244,184.319 126.237,183.993 126.458,171.812 136.129,172.198 
	141.927,176.5 141.159,214.618 76.554,215.597 "/>
<line fill="none" stroke="#231F20" x1="201.767" y1="236.57" x2="201.767" y2="235.668"/>
<path fill="#231F20" d="M137.958,164.1h-11.284v-13.7H92.99v13.525H76.031l0.355-45.395h66.548v40.593L137.958,164.1z
	 M127.674,163.1h9.87l4.391-4.391V119.53H77.378l-0.339,43.395H91.99v-13.525h35.684V163.1z"/>
<polygon fill="none" stroke="#231F20" points="76.882,171.056 92.142,171.056 92.142,183.889 126.132,183.889 126.132,171.403 
	136.19,171.403 141.74,176.952 141.74,215.104 76.535,215.104 "/>
<path fill="none" stroke="#231F20" stroke-width="1.004" d="M125.98,174.984c0,0-3.534-2.337-3.683-7.513
	c-0.147-5.175,4.566-8.332,4.566-8.332"/>
<path fill="none" stroke="#231F20" d="M314.457,155.073c0,0,16.184,3.286,16.549-4.022c0.366-7.307-16.422-5.482-16.422-5.482
	l0.226-16.826h58.27v11.099c0,0-13.877,12.137-13.528,27.746c0.346,15.609,13.872,28.789,13.872,28.789v10.057h-59.654
	L314.457,155.073z"/>
<path fill="none" stroke="#231F20" d="M373.423,146.431v18.035h-9.363c0,0,0.694-5.896,2.774-9.366
	C368.915,151.633,373.423,146.431,373.423,146.431z"/>
<path fill="none" stroke="#231F20" d="M373.771,172.098v17.688c0,0-4.507-4.511-6.589-7.631c-2.082-3.122-3.469-10.406-3.469-10.406
	L373.771,172.098z"/>
<polyline fill="none" stroke="#231F20" points="564.184,127.008 571.812,127.008 571.812,166.547 531.928,166.547 531.928,147.818 
	531.928,127.354 531.928,147.473 531.928,127.702 537.823,127.702 537.823,146.777 "/>
<path fill="none" stroke="#231F20" d="M537.823,133.944c0,0,4.162-3.469,4.162-10.405s-4.162-10.058-4.162-10.058V99.956h-5.548
	V85.735h39.19v34.683h-7.629"/>
<line fill="none" stroke="#231F20" x1="532.619" y1="120.418" x2="532.619" y2="99.956"/>
<path fill="none" stroke="#231F20" d="M57.948,74.264c0,0,67.329-19.182,76.732-19.56c9.404-0.376,17.115,1.316,22.381,8.276
	c5.265,6.958,6.582,11.847,6.582,11.847"/>
<path fill="none" stroke="#231F20" d="M388.949,74.452l-59.994-17.303c0,0-14.292-2.256-19.746-0.94
	c-5.455,1.315-13.917,6.583-18.43,18.808"/>
<rect x="46.355" y="149.59" fill="none" stroke="#231F20" stroke-width="1.053" width="16.809" height="14.167"/>
<rect x="48.183" y="171.327" fill="none" stroke="#231F20" stroke-width="1.053" width="14.981" height="5.668"/>
<rect x="46.721" y="156.533" fill="none" stroke="#231F20" stroke-width="1.141" width="12.424" height="7.134"/>
<rect x="128.206" y="157.996" fill="none" stroke="#231F20" stroke-width="0.952" width="6.953" height="5.113"/>
<rect x="127.475" y="172.246" fill="none" stroke="#231F20" stroke-width="0.86" width="6.489" height="5.115"/>
<rect x="408.796" y="147.377" fill="none" stroke="#231F20" width="6.578" height="16.81"/>
<rect x="415.399" y="149.571" fill="none" stroke="#231F20" stroke-width="1.008" width="20.412" height="14.508"/>
<rect x="415.481" y="171.633" fill="none" stroke="#231F20" stroke-width="0.995" width="6.943" height="14.843"/>
<rect x="422.425" y="171.633" fill="none" stroke="#231F20" stroke-width="0.979" width="12.008" height="14.843"/>
<rect x="440.585" y="176.244" fill="none" stroke="#231F20" width="12.789" height="13.155"/>
<rect x="453.374" y="176.244" fill="none" stroke="#231F20" stroke-width="0.993" width="10.599" height="19.457"/>
<rect x="465.07" y="183.916" fill="none" stroke="#231F20" stroke-width="0.99" width="5.479" height="5.734"/>
<rect x="463.973" y="189.765" fill="none" stroke="#231F20" stroke-width="1.075" width="6.647" height="5.92"/>
<polyline fill="none" stroke="#231F20" stroke-width="1.013" points="470.59,171.272 470.59,195.634 468.033,195.634 
	468.033,205.756 "/>
<rect x="608.242" y="109.396" fill="none" stroke="#231F20" stroke-width="0.978" width="5.935" height="9.865"/>
<rect x="614.194" y="101.356" fill="none" stroke="#231F20" stroke-width="0.985" width="20.829" height="18.085"/>
<path fill="none" stroke="#231F20" d="M252.411,128.89"/>
<text transform="matrix(1 0 0 1 98.1641 168.2305)" class="st2" font-size="5.3">ATRIUM A</text>

<text transform="matrix(1 0 0 1 330.3828 170.3936)" class="st2" font-size="5.3">ATRIUM B</text>

<text transform="matrix(1 0 0 1 543.4736 125.2119)" class="st2" font-size="5.3">ATRIUM C</text>

<line fill="#FFFFFF" x1="71.467" y1="143.074" x2="70.274" y2="146.857"/>
<line fill="#FFFFFF" x1="308.759" y1="137.064" x2="307.566" y2="140.847"/>
<line fill="#FFFFFF" x1="254.116" y1="224.601" x2="255.308" y2="220.817"/>
<line fill="#FFFFFF" x1="259.982" y1="210.773" x2="261.174" y2="206.99"/>
<path fill="none" stroke="#231F20" stroke-width="0.5" d="M163.472,74.766c-1.354-5.111-4.059-13.08-16.235-18.642
	c-12.175-5.561-42.122,5.179-45.547,6.078c-3.426,0.9-39.125,11.813-41.531,11.813"/>
<rect x="619.542" y="104.703" fill="#231F20" width="10.864" height="12.598"/>
<rect x="619.542" y="104.703" fill="none" stroke="#231F20" stroke-width="1.554" width="10.864" height="12.598"/>
<polyline fill="none" stroke="#FFFFFF" stroke-width="1.554" points="623.538,107.55 623.538,111.838 626.381,111.764 
	628.179,115.578 629.891,114.089 "/>
<path fill="#FFFFFF" d="M623.538,107.273c0.468,0,0.847-0.379,0.847-0.846c0-0.468-0.379-0.848-0.847-0.848
	c-0.464,0-0.844,0.38-0.844,0.848C622.694,106.894,623.074,107.273,623.538,107.273"/>
<line fill="none" stroke="#FFFFFF" stroke-width="1.554" x1="624.174" y1="109.219" x2="625.822" y2="109.219"/>
<path fill="none" stroke="#FFFFFF" stroke-width="1.554" d="M623.545,109.161c-1.844,0.316-3.251,1.923-3.251,3.859
	c0,2.163,1.754,3.913,3.915,3.913c1.487,0,2.782-0.829,3.445-2.052"/>
<line fill="none" stroke="#FFFFFF" stroke-width="0.331" x1="622.864" y1="108.254" x2="622.864" y2="110.316"/>
<text transform="matrix(1 0 0 1 320.3213 272.3262)" class="st0 st7 st12" font-size="6">Office Space</text>
<text transform="matrix(1 0 0 1 543.4736 215.876)" class="st0 st7 st12" font-size="6">Office Space</text>
<text transform="matrix(1 0 0 1 100.2041 269.2402)" class="st0 st7 st12" font-size="6">Office Space</text> 
<path fill="none" stroke="#231F20" stroke-width="0.3" d="M516.44,199.81"/>
<path d="M587.952,126.796l-10.526,10.416v33.864h-142.46v-0.001h-48.395l-8.444,8.444v32.309h-69.481v-29.516l-10.256-11.757
	h-98.922h-0.5h-44.948l-6.537,6.537v43.406H71.136l-0.347-49.596H17.074v11.058h5.549v13.222h-6.243v64.121h41.58v-5.201h30.909
	v5.201h60.656v-5.548h31.254v5.548h21.42v-16.648h49.334v18.036h21.116v-6.242h31.256v6.244l60.447-0.284v-5.541l30.77,0.271v5.899
	h39.845v-54.646h128.019v-2.745h22.595v3.433h50.937v-80.284H587.952z M191.556,172.014h6.673v5.943h-6.673V172.014z
	 M164.15,172.014h26.405v6.943v6.309h-9.597v-9.367h-1v9.367H164.15V172.014z M17.379,196.183h6.243v-15.222h-5.549v-9.058h51.722
	l0.339,48.519H17.379V196.183z M156.325,252.756h-7.801v5.548h-22.206l-0.006-14.491h7.964v-22.288h-1v21.288h-7.964l0.006,15.491
	h-35.45v-5.201H56.959v5.201h-39.58v-36.882h52.763l0,0.077h77.721v0.035h8.462V252.756z M201.229,235.004h-0.031v23.3h-19.42
	v-5.548h-24.453v-32.222h-8.843v-43.027l5.951-5.951h8.718v14.71h28.405v-7.309h6.912v6.818h0.5h2.274l-0.028,39.801h0.5l-0.5,0.001
	L201.229,235.004z M202.24,241.655l-0.027-16.08l0.029-40.8h-0.544h-2.23v-13.22h54.298l0.005,70.126h-1.239v-0.026H202.24z
	 M433.966,260.038h-37.845v-5.892l-32.77-0.288v5.555l-58.447,0.276v-6.24h-33.256v6.242h-19.116v-16.998h2.25l-0.005-71.138h43.158
	l9.711,11.132v30.141h71.481v-32.895l7.858-7.858h46.98V260.038z M487.417,205.398h-52.412V172.07h52.412V205.398z M505.542,205.398
	h-17.125V172.07h17.125V205.398z M523.487,205.398h-16.945V172.07h16.945V205.398z M635.521,206.086h-48.948v-3.433H561.99v2.745
	h-37.511V172.07h53.94v-34.443l9.94-9.836h47.161V206.086z"/>
<path fill="#C4E3F7" d="M335.706,127.739"/>
<polyline fill="none" stroke="#231F20" stroke-width="1.1142" points="336.092,123.591 336.092,145.897 343.045,145.897 "/>
<path fill="none" stroke="#231F20" d="M451.912,239.615"/>
<path d="M636.475,96.914V38.688H567.5v3.103h-2.474V26.622h-26.66v14.824h-3.167v-3.101h-68.284l0.365,72.471h-30.928V74.284
	H318.711v18.73h-10.502c-0.329-1.765-1.736-8.533-4.532-11.957c-3.154-3.863-7.737-6.426-9.385-6.426h-42.38v53.759h-5.923v-25.318
	H208.3v24.971h-5.902v-1.05h-0.025l-0.134-52.855h-42.464l-0.187,0.036c-1.4,0.564-7.244,3.365-10.247,6.766
	c-2.503,2.834-4.14,9.319-4.533,11.002h-9.854V74.138H17.079l-0.694,72.133c0.043,0.336,1.118,8.267,5.721,12.188
	c4.461,3.798,6.7,5.704,12.462,5.704h36.918v-49.576h77.038l0.008,38.862c-0.03,0.167-0.695,4.128,2.896,8.104
	c3.331,3.69,4.072,3.684,8.19,3.66l38.838-0.005l0,0.241l99.644-0.337h0.207l11.021-11.044v-29.536h68.397v31.789l8.426,8.443
	h49.199v0.06h80.481l10.003-9.941V82.722l3.309-3.046h46.399l2.014,3.188v26.859l10.352,10.29h47.701v-18.805l-2.256-2.241v-2.052
	H636.475z M70.487,163.164H34.568c-5.394,0-7.406-1.713-11.814-5.465c-4.308-3.671-5.369-11.479-5.375-11.488l0.352-36.341h52.589
	v5.225h0.166V163.164z M201.398,164.211h-40.582l-1.204,0.004c-3.998,0.021-4.413,0.027-7.443-3.331
	c-3.248-3.596-2.661-7.223-2.646-7.346v-39.95H71.321v-4.718h-53.58l0.327-33.733h115.889v17.804h11.655l0.085-0.394
	c0.017-0.079,1.737-7.937,4.395-10.946c2.551-2.89,7.711-5.612,9.782-6.464h41.37l0.136,53.906h0.019V164.211z M209.299,104.071
	h35.69v5.92h-35.69V104.071z M308.329,153.655l-10.438,10.46l-95.493,0.322v-35.395h6.901v-18.05h35.69v18.397h7.921v-4.823h55.418
	V153.655z M378.724,155.908v-32.374h-70.395v0.032h-55.418V75.63h41.381c1.119,0,5.533,2.289,8.611,6.059
	c2.994,3.667,4.381,11.825,4.395,11.907l0.069,0.417h12.343v-18.73h115.644v88.483h-48.788L378.724,155.908z M452.875,163.829
	h-16.521l0.36-52.017h16.16V163.829z M524.839,154.47l-9.419,9.359h-61.545v-52.017h13.406v23.544h0.085v0.034h57.473V154.47z
	 M542.806,78.679h-14.051l-3.916,3.606v52.106h-56.558v-22.579h0.001l-0.001-0.194v-6.531h-0.033l-0.331-65.746h66.286v3.101h5.159
	v-0.021l3.443,0.861V78.679z M634.613,101.622v17.393H588.32l-9.768-9.708V82.575l-2.461-3.896h-32.286V42.502l-4.443-1.111V27.619
	h24.668v15.169h4.466v-3.103h66.982v56.232h-3.121v3.464L634.613,101.622z"/>
<text transform="matrix(1 0 0 1 79.9897 101.0176)" fill="#231F20" class="st2" font-size="5">A-415</text>
<text transform="matrix(1 0 0 1 35.9063 137.9561)" fill="#231F20" class="st2" font-size="5">A-410</text>
<text transform="matrix(1 0 0 1 36.4063 211.3867)" fill="#231F20" class="st2" font-size="5">A-474</text>
<text transform="matrix(1 0 0 1 100.9868 140.7441)" fill="#231F20" class="st2" font-size="5">A-407</text>
<text transform="matrix(1 0 0 1 100.998 208.5117)" fill="#231F20" class="st2" font-size="5">A-455</text>
<text transform="matrix(1 0 0 1 66.1636 242.5)" fill="#231F20" class="st2" font-size="5">A-475</text>
<text transform="matrix(1 0 0 1 221.3364 215.8818)" fill="#231F20" class="st2" font-size="5">B-482</text>
<text transform="matrix(1 0 0 1 491.0703 91.7109)" fill="#231F20" class="st2" font-size="5">C-412</text>
<text transform="matrix(1 0 0 1 599.8281 168.2305)" fill="#231F20" class="st2" font-size="5">C-450</text>
<text transform="matrix(1 0 0 1 507.6816 189.9746)" fill="#231F20" class="st2" font-size="5">C-462</text>
<text transform="matrix(1 0 0 1 489.3496 189.9746)" fill="#231F20" class="st2" font-size="5">C-468</text>
<text transform="matrix(1 0 0 1 472.0996 189.9746)" fill="#231F20" class="st2" font-size="5">C-470</text>
<text transform="matrix(1 0 0 1 589.7656 76.6377)" fill="#231F20" class="st2" font-size="5">C-420 / C-436</text>
<text transform="matrix(1 0 0 1 69.9014 93.3223)" class="st2" font-size="5.6">Medtronic</text>
<text transform="matrix(1 0 0 1 20.5381 130.2119)" class="st2" font-size="5.3">Upper Echelon</text>
<text transform="matrix(1 0 0 1 22.6631 203.5703)" class="st2" font-size="5.3">Bitty Advance</text>
<text transform="matrix(1 0 0 1 67.2471 235.2578)" class="st2" font-size="5.3">Avis</text>
<text transform="matrix(1 0 0 1 84.5459 134.2646)" class="st2" font-size="5.3">Smart Chip Tray</text>
<text transform="matrix(1 0 0 1 538.376 190.5137)" class="st2" font-size="5.3">Stars Group SVC USA Corp.</text>
<text transform="matrix(1 0 0 1 506.8809 197.5684)"><tspan x="0" y="0" class="st2"  font-size="2.951">Equiturn</tspan><tspan x="0.508" y="3.541" class="st2"  font-size="2.951">Business</tspan></text>
<text transform="matrix(1 0 0 1 489.1611 197.5684)"><tspan x="0" y="0" class="st2"  font-size="3.4166">Integra</tspan><tspan x="0.913" y="4.1" class="st2"  font-size="3.4166">Beauty</tspan></text>
<text transform="matrix(1 0 0 1 469.3115 202.3574)" class="st2"  font-size="3.912">CSI DMC</text>
<text transform="matrix(1 0 0 1 576.8115 68.5645)" class="st2"  font-size="5.3">Chiquita Fresh</text>
<text transform="matrix(1 0 0 1 549.7031 284.3262)" fill="#231F20" class="st2"  font-size="10">DCOTA 4th Floor</text>
<g>
	<rect x="172.262" y="168.27" fill="#231F20" width="11.722" height="15.432"/>
	<path fill="#FFFFFF" d="M180.502,171.127c0.458,0,0.831-0.454,0.831-1.021c0-0.563-0.373-1.017-0.831-1.017
		c-0.461,0-0.832,0.454-0.832,1.017C179.67,170.673,180.041,171.127,180.502,171.127"/>
	<path fill="#FFFFFF" d="M180.872,171.02c0.043,0.195-0.087,0.386,0.087,0.386c0.173,0,0.739-0.048,1.001,0.098
		c0.262,0.143,0.349,0.335,0.391,0.624c0.044,0.289,0.262,2.979,0.217,3.507c-0.042,0.53,0,0.626-0.304,0.673
		c-0.305,0.051-0.262,0-0.305-0.335c-0.044-0.338-0.218-2.402-0.218-2.402l-0.13,1.442c0.185,1.63,0.218,2.455,0.218,4.013
		c0.043,0.288,0.043,1.514,0,2.041c-0.043,0.53,0,0.624-0.305,0.675c-0.306,0.048-0.436,0.048-0.479-0.29
		c-0.045-0.336-0.522-5.047-0.522-5.047s-0.478,4.711-0.522,5.047c-0.043,0.338-0.175,0.338-0.479,0.29
		c-0.305-0.051-0.26-0.145-0.305-0.675c-0.043-0.527-0.043-1.753,0-2.041c0-1.558,0.032-2.383,0.218-4.013l-0.131-1.442
		c0,0-0.174,2.064-0.218,2.402c-0.042,0.335,0,0.386-0.304,0.335c-0.304-0.047-0.262-0.143-0.304-0.673
		c-0.043-0.528,0.174-3.218,0.217-3.507c0.042-0.289,0.129-0.481,0.391-0.624c0.263-0.146,0.828-0.098,1.002-0.098
		c0.173,0,0.044-0.19,0.087-0.386H180.872z"/>
	<path fill="#FFFFFF" d="M173.596,178.814c-0.059-1.372,0.742-2.484,0.914-3.993l-0.122-1.065c0,0-0.281,1.954-0.32,2.265
		c-0.041,0.312,0,0.355-0.281,0.312c-0.281-0.043-0.243-0.135-0.281-0.622c-0.04-0.488,0.36-2.486,0.402-2.752
		c0.04-0.266,0.12-0.442,0.36-0.577c0.242-0.134,0.645-0.087,0.806-0.087c0.16,0,0.039-0.179,0.081-0.358h0.641
		c0.041,0.18-0.08,0.358,0.082,0.358c0.16,0,0.563-0.047,0.804,0.087c0.242,0.135,0.321,0.312,0.363,0.577
		c0.04,0.266,0.401,2.264,0.361,2.752c-0.041,0.487,0,0.579-0.282,0.622c-0.281,0.044-0.241,0-0.281-0.312
		c-0.042-0.311-0.432-2.265-0.432-2.265l-0.01,1.065c0.17,1.509,1,2.621,1.057,3.993H173.596z"/>
	<path fill="#FFFFFF" d="M175.307,177.416c0,0-0.158,3.783-0.186,4.099c-0.024,0.313-0.101,0.313-0.279,0.27
		c-0.178-0.046-0.154-0.136-0.178-0.63c-0.026-0.495-0.375-3.936-0.335-4.201l2.131-0.043c0.041,0.266-0.24,3.749-0.265,4.244
		c-0.025,0.494,0,0.584-0.179,0.63c-0.179,0.044-0.255,0.044-0.28-0.27c-0.027-0.315-0.133-4.093-0.133-4.093"/>
	<path fill="#FFFFFF" d="M175.454,171.838c0,0,1.025,0.074,1.017,0.029c-0.011-0.046-0.152-0.751-0.152-0.816
		c0-0.141-0.377-1.047-0.854-1.021h-0.021c-0.478-0.025-0.853,0.881-0.854,1.021c0,0.065-0.113,0.719-0.121,0.766
		C174.458,171.862,175.454,171.838,175.454,171.838"/>
</g>
<g>
	<rect x="419.833" y="160.578" fill="#231F20" width="11.723" height="15.43"/>
	<path fill="#FFFFFF" d="M428.071,163.435c0.458,0,0.83-0.456,0.83-1.02c0-0.564-0.372-1.019-0.83-1.019
		c-0.462,0-0.832,0.454-0.832,1.019C427.239,162.979,427.609,163.435,428.071,163.435"/>
	<path fill="#FFFFFF" d="M428.439,163.327c0.044,0.193-0.087,0.384,0.09,0.384c0.174,0,0.739-0.048,1.002,0.098
		c0.261,0.144,0.348,0.336,0.39,0.626c0.047,0.287,0.263,2.979,0.217,3.506c-0.043,0.529,0,0.626-0.304,0.673
		c-0.303,0.051-0.264,0-0.303-0.335c-0.048-0.338-0.219-2.402-0.219-2.402l-0.132,1.441c0.187,1.631,0.22,2.456,0.22,4.014
		c0.043,0.289,0.043,1.514,0,2.041c-0.044,0.53,0,0.625-0.307,0.675c-0.306,0.046-0.437,0.046-0.478-0.29
		c-0.046-0.336-0.524-5.047-0.524-5.047s-0.479,4.711-0.52,5.047c-0.044,0.336-0.176,0.336-0.482,0.29
		c-0.304-0.05-0.258-0.145-0.304-0.675c-0.043-0.527-0.043-1.752,0-2.041c0-1.558,0.033-2.383,0.218-4.014l-0.132-1.441
		c0,0-0.174,2.064-0.216,2.402c-0.044,0.335,0,0.386-0.304,0.335c-0.304-0.047-0.262-0.144-0.304-0.673
		c-0.046-0.527,0.171-3.219,0.216-3.506c0.043-0.29,0.129-0.482,0.392-0.626c0.262-0.146,0.828-0.098,1.002-0.098
		c0.172,0,0.043-0.19,0.085-0.384H428.439z"/>
	<path fill="#FFFFFF" d="M421.166,171.122c-0.059-1.374,0.743-2.485,0.912-3.994l-0.121-1.063c0,0-0.279,1.952-0.317,2.263
		c-0.043,0.312,0,0.356-0.283,0.312c-0.282-0.044-0.242-0.136-0.282-0.622c-0.04-0.487,0.361-2.486,0.403-2.751
		c0.039-0.269,0.119-0.443,0.36-0.577c0.24-0.135,0.644-0.089,0.805-0.089c0.159,0,0.039-0.179,0.083-0.355h0.64
		c0.04,0.177-0.079,0.355,0.081,0.355c0.159,0,0.563-0.046,0.804,0.089c0.24,0.134,0.321,0.309,0.363,0.577
		c0.04,0.265,0.401,2.264,0.361,2.751c-0.04,0.486,0,0.578-0.28,0.622c-0.283,0.045-0.242,0-0.283-0.312
		c-0.042-0.311-0.43-2.263-0.43-2.263l-0.012,1.063c0.17,1.509,1.001,2.62,1.056,3.994H421.166z"/>
	<path fill="#FFFFFF" d="M422.876,169.723c0,0-0.156,3.784-0.186,4.098c-0.025,0.315-0.103,0.315-0.28,0.27
		c-0.178-0.045-0.153-0.137-0.178-0.629c-0.025-0.495-0.374-3.936-0.335-4.202l2.13-0.045c0.043,0.268-0.237,3.752-0.265,4.247
		c-0.024,0.492,0,0.584-0.179,0.629c-0.179,0.046-0.255,0.046-0.278-0.27c-0.025-0.313-0.134-4.092-0.134-4.092"/>
	<path fill="#FFFFFF" d="M423.025,164.145c0,0,1.023,0.074,1.015,0.029c-0.013-0.046-0.153-0.75-0.153-0.817
		c0-0.139-0.376-1.045-0.854-1.021h-0.018c-0.479-0.024-0.854,0.882-0.857,1.021c0,0.067-0.11,0.72-0.119,0.767
		C422.03,164.169,423.025,164.145,423.025,164.145"/>
</g>
<rect x="80.546" y="189.975" fill="none" width="55.333" height="12.692"/>
<text transform="matrix(1 0 0 1 88.2773 193.9072)"><tspan x="0" y="0" class="st2"  font-size="5.3">Empire State </tspan><tspan x="5.361" y="6.36" class="st2"  font-size="5.3">Holdings</tspan></text>
<rect x="205.221" y="195.706" fill="none" width="46.75" height="16.5"/>
<text transform="matrix(1 0 0 1 207.9502 199.6387)"><tspan x="0" y="0" class="st2"  font-size="5.3">Management </tspan><tspan x="10.708" y="6.36" class="st2"  font-size="5.3">Office</tspan></text>
<rect x="476.669" y="70.564" fill="none" width="45.296" height="13.073"/>
<text transform="matrix(1 0 0 1 483.208 74.4971)"></text>

</svg>


	<store-modal
      :title="store.name"
      :image="store.business_image"
      :suite="store.suite"
      :website="store.website"
      :contact="store.contact"
      :phone="store.phone"
      :email="store.email"
      :target="target"
      :targetzone="targetzone"
    />
	</div>
</template>

<script>
// @ is an alias to /src
import StoreModal from '@/components/StoreModal'
export default {
  name: 'floor4',
  components:{
    StoreModal,
  },
  data(){
    return {
      store:'B-100',
    }
  },
  methods:{
    clickStore(e) {
		setTimeout(() => {
                  this.$root.$emit('bv::hide::popover');
            }, 0);
			this.targetzone = '';
      e.target.className.baseVal = "selected";
      this.target = e.target.id;
      this.store = this.storeData(this.target);
      this.targetzone = this.target;

      //this.$bvModal.show('modal-center');
	  setTimeout(() => {
                  this.$root.$emit('bv::show::popover',this.targetzone)
            }, 1000);
    },
    resetModal() {
      console.log("reset modal");
    },

    storeData(payload) {
      return this.stores.find(x => x.suite === payload)
    },
	showStorePopover(){
          this.targetzone = this.$route.params.id;
          if (typeof(this.$route.params.id) !== 'undefined'){

		
			setTimeout(() => {
					this.store = this.storeData(this.$route.params.id);
					this.$root.$emit('bv::show::popover',this.targetzone);
				}, 400);
		}
    }
  },
  mounted() {
    window.addEventListener("contextmenu", (event) => {
      event.preventDefault();
    });
  },
  computed:{
    stores() {
      return this.$store.state.suites;
    }
  },

  created: function(){
        if (typeof(this.$route.params.id) !== 'undefined'){
			this.showStorePopover()
	}
  }
}
</script>

<style scoped type="text/css">
.selected {
	stroke: #002868 !important;
	stroke-width: 1px;
	stroke-linejoin: round;
	fill: #FFFFFF !important;
	cursor: pointer;
	fill-opacity: .7;
	}
	.st0{fill:#000100;}
	.st1{font-family: 'Montserrat', sans-serif;}
	/* .st2{font-size:11px;} */
	.st3{fill:#E6E7E7;}
	.st4{fill:#DAE29F;}
	.st5{fill:#C5E1F5;}
	.st6{fill:#8FC4E3;}
	.st7{font-family: 'Montserrat', sans-serif;}
	.st8{font-size:5.9417px;}
	.st9{font-size:6.6326px;}
	.st10{font-size:5.458px;}
	.st11{font-size:5.3199px;}
	.st12{font-size:6.9089px;}
	.st13{font-size:4.9053px;}
	.st14{fill:#FFFFFF;}
	.st15{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
</style>